import { HelpURLSMap } from "Constants";
import React from "react";
import { useEnv } from "store";

export const HelpLink: React.FC<{ location?: string; testId?: string }> = ({
  testId,
  location = null,
  children
}) => {
  const { envName } = useEnv();
  return (
    <a
      href={HelpURLSMap[envName] + (location ?? "")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
    >
      {children}
    </a>
  );
};

export default HelpLink;
